import { animationBlockConfim, animationNoneConfim } from './animation';
Vue.prototype.$confirm = (message, titile, action) => {
    if(typeof(message) != 'string'){
        console.error('Tham số đầu tiên là message, định dạng string');
        return;
    }
    if(typeof(titile) != 'string'){
        console.error('Tham số thứ 2 là tiêu đề, định dạng string');
        titile = '';
    }

    if(typeof(action) != 'object'){
        console.error('Tham số thứ 3 chỉ nhận 1 object gồm các key confirmButtonText, cancelButtonText, type (tất cả đều là string)');
        return;
    }

    let confirmButtonText = 'OK';
    if(action.confirmButtonText){
        confirmButtonText = action.confirmButtonText;
    }
    let cancelButtonText = 'Cancel';
    if(action.cancelButtonText){
        cancelButtonText = action.cancelButtonText;
    }

    let classType = '';
    let type = action.type;
    if(type == 'success'){
        classType = 'ldc-alert-success';
    }else if(type == 'warning'){
        classType = 'ldc-alert-warning';
    }else if(type == 'error'){
        classType = 'ldc-alert-error';
    }else if(type == 'info'){
        classType = 'ldc-alert-info';
    }
    
    if(Vue.prototype.$detect == 'web'){
        window.enterConfim = (e) => {
            if(e.keyCode == 13){
                confirmLinhdanchuConfirm(this);
            }else if(e.keyCode == 27){
                closeLinhdanchuConfirm(this);
            }
        }
    
        window.addEventListener('keydown', enterConfim);
    }

    // lấy body
    let body = document.querySelector('body');
    // thêm mới thông báo vào cuối body
    body.insertAdjacentHTML('beforeend', divMessageConfirm(message, titile, confirmButtonText, cancelButtonText, classType));
    animationBlockConfim();
    Vue.prototype.$overflowHidenBody();
    var el;
    if(Vue.prototype.$detect == 'web'){
        el = document.querySelectorAll('.ldc-alert-box');
    }else{
        el = document.querySelectorAll('.ldc-confirm-mobile');
    }
    if(el.length > 0){
        el = el[el.length -1];
        return new Promise((res, rej) => {
            window.confirmLinhdanchuConfirm = (e) => {
                Vue.prototype.$removeOverflowHidenBody();
                if(Vue.prototype.$detect == 'web'){
                    window.removeEventListener('keydown', enterConfim);
                }
                if(Vue.prototype.$detect == 'web'){
                    animationNoneConfim(el, () => {
                        el.remove();
                        return res();
                    });
                }else{
                    el.remove();
                    return res();
                }
                
                
            }
            window.closeLinhdanchuConfirm = (e) => {
                Vue.prototype.$removeOverflowHidenBody();
                if(Vue.prototype.$detect == 'web'){
                    window.removeEventListener('keydown', enterConfim);
                }
                if(Vue.prototype.$detect == 'web'){
                    animationNoneConfim(el, () => {
                        el.remove();
                        return rej();
                    });
                }else{
                    el.remove();
                    return rej();
                }
            }
        })
    }
    
}


let divMessageConfirm = (message, titile, confirmButtonText, cancelButtonText, classType) => {
    if(Vue.prototype.$detect == 'web'){
        return `<div class="position-fixed d-flex align-items-center justify-content-center ldc-alert-box">
                <div class="ldc-alert-content bg-white fs-14px p-15px rounded-lg">
                    <div class="fs-16px ldc-alert-title">${titile}</div>
                    <div class="fs-14px mt-2 mb-10px ldc-alert-message">${message}</div>
                    <div class="ldc-alert-button text-right">
                        <button class="btn btn-sm mr-2"
                            onclick="closeLinhdanchuConfirm(this)">${cancelButtonText} <span class="fs-10px font-italic">(Esc)</span></button>
                        <button class="btn btn-sm ${classType}"
                            onclick="confirmLinhdanchuConfirm(this)">${confirmButtonText} <span class="fs-10px font-italic">(Enter)</span></button>
                    </div>
                </div>
            </div>`
    }
    let domTile = !Vue.prototype.$isAndroid ? `<div class="title">
                                                    ${titile}
                                                </div>` : '';
    let height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    return `<div class="ldc-confirm-mobile" style="height: ${height}px">
                <div class="${!Vue.prototype.$isAndroid ? 'confirm-ios' : 'confirm-android'}">
                    <div class="content-confirm">
                        ${domTile}
                        <div class="content mt-1">
                            ${message}
                        </div>
                    </div>
                    <div class="btn-custom">
                        <div class="btn-cancel" onclick="closeLinhdanchuConfirm(this)">
                            ${cancelButtonText}
                        </div>
                        <div class="btn-confirm ${classType}" onclick="confirmLinhdanchuConfirm(this)">
                            ${confirmButtonText}
                        </div>
                    </div>
                </div>
            </div>`
    
}